/**
 * @generated SignedSource<<ea604e44fb3395e4155af1df8e1e9f44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type VerifyHarvestIntegrationInput = {
  harvestAccountName: string;
  harvestUserName: string;
  harvestPassword: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type verifyHarvestIntegrationMutation$variables = {
  input: VerifyHarvestIntegrationInput;
};
export type verifyHarvestIntegrationMutation$data = {
  readonly verifyHarvestIntegration: {
    readonly success: boolean | null;
    readonly message: string | null;
    readonly company: {
      readonly id: string;
      readonly harvestEnabled: boolean | null;
      readonly harvestAccountName: string | null;
      readonly harvestUserName: string | null;
      readonly harvestPassword: string | null;
    } | null;
  } | null;
};
export type verifyHarvestIntegrationMutation = {
  variables: verifyHarvestIntegrationMutation$variables;
  response: verifyHarvestIntegrationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyHarvestIntegrationPayload",
    "kind": "LinkedField",
    "name": "verifyHarvestIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestUserName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestPassword",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "verifyHarvestIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "verifyHarvestIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9c09d9318f2d387e09d5c4de64dbdd5e",
    "id": null,
    "metadata": {},
    "name": "verifyHarvestIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation verifyHarvestIntegrationMutation(\n  $input: VerifyHarvestIntegrationInput!\n) {\n  verifyHarvestIntegration(input: $input) {\n    success\n    message\n    company {\n      id\n      harvestEnabled\n      harvestAccountName\n      harvestUserName\n      harvestPassword\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed3c6b192ec368ec2d356a55fb4dabfc";

export default node;
